export function resolveTagLabel<T>(
  items: T[],
  value: string,
  getItemValue: (item: T) => string,
  getItemLabel: (item: T) => string,
  compareValue: (itemValue: string, selectedValue: string) => boolean
): string {
  const selectedValue = String(value)
  const item = (items || []).find((candidate) => compareValue(getItemValue(candidate), selectedValue))

  return item === undefined ? selectedValue : getItemLabel(item)
}
